import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Calendar, Award } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Commits = () => {
  const [commits, setCommits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCommits = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API}/commits`);
        setCommits(response.data);
        setError(null);
      } catch (err) {
        console.error('Error fetching commits:', err);
        setError('Failed to load commits. Please try again later.');
      } finally {
        setLoading(false);
      }
    };
    
    fetchCommits();
  }, []);

  if (loading) {
    return (
      <div className="page-content">
        <section className="page-hero">
          <div className="container">
            <h1 className="display-large">Recent Commits</h1>
            <p className="body-large">Loading commits...</p>
          </div>
        </section>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-content">
        <section className="page-hero">
          <div className="container">
            <h1 className="display-large">Recent Commits</h1>
            <p className="body-large error-message">{error}</p>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="page-content">
      <section className="page-hero">
        <div className="container">
          <h1 className="display-large">Recent Commits</h1>
          <p className="body-large">Celebrating our players' collegiate commitments</p>
        </div>
      </section>

      <section className="commits-section">
        <div className="container">
          {commits.length === 0 ? (
            <p className="body-large" style={{ textAlign: 'center' }}>No commits to display yet.</p>
          ) : (
            <div className="commits-grid">
              {commits.map((commit) => (
                <div key={commit.id} className="commit-card network-card">
                  <div className="commit-photo">
                    <img src={commit.photo_url} alt={commit.name} />
                    <div className="commit-badge">
                      <Award size={24} />
                    </div>
                  </div>
                  <div className="commit-info">
                    <h3 className="network-card-title">{commit.name}</h3>
                    <div className="commit-college">{commit.committed_college}</div>
                    <div className="commit-details">
                      <div className="detail-row">
                        <span className="detail-label">Position:</span>
                        <span className="detail-value">{commit.position}</span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Class of:</span>
                        <span className="detail-value">{commit.graduation_year}</span>
                      </div>
                      <div className="detail-row">
                        <Calendar size={16} />
                        <span className="detail-value">{new Date(commit.announcement_date).toLocaleDateString()}</span>
                      </div>
                    </div>
                    <div className="commit-highlights">
                      <p className="body-small">{commit.highlights}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Commits;